import {createStore, combineReducers} from "redux";
import {employeeReducer, setEmployee} from "./employeeReducer";
import {serviceReducer, setService} from "./serviceReducer";
import {dateReducer, setDate} from "./dateReducer";
import {composeWithDevTools} from "redux-devtools-extension";
import {branchReducer, setBranch} from "./branchReducer";
import {formReducer} from "./formReducer";
import {checkDate, retrieveCachedData} from "./localStorageUtils";
import {bookingValidateReducer, setBookingValidate} from "./bookingValidateReducer";
import {companyReducer, setCompany} from "./companyReducer";

const rootReducer = combineReducers({
    employeeReducer,
    serviceReducer,
    dateReducer,
    branchReducer,
    formReducer,
    bookingValidateReducer,
    companyReducer
})


export const store = createStore(rootReducer, composeWithDevTools());

const reducerActions = {
    branchData : setBranch,
};


const pathParts = window.location.pathname.split("/").filter(Boolean);

const companyIndex = pathParts.indexOf("company");
const companyId = companyIndex !== -1 ? pathParts[companyIndex + 1] : null;

let branchId = null;

const branchSegmentIndex = pathParts.findIndex(p => p.startsWith("branch"));
if (branchSegmentIndex !== -1 && pathParts[branchSegmentIndex + 1]) {
    branchId = pathParts[branchSegmentIndex + 1];
}

if (checkDate()) {
    reducerActions.dateData = setDate;
    reducerActions.employeeData = setEmployee;
    reducerActions.serviceData = setService;
    reducerActions.companyData = setCompany;
}
reducerActions.validateData = setBookingValidate;

let companyIdFromStorage = null;

if (localStorage.getItem('companyData')) {
    companyIdFromStorage = JSON.parse(localStorage.getItem('companyData')).companyId
}

let branchIdFromStorage = null;

if (localStorage.getItem('branchData')) {
    branchIdFromStorage = JSON.parse(localStorage.getItem('branchData')).id
}


if (Number(companyIdFromStorage) === Number(companyId) && (Number(branchIdFromStorage) === Number(branchId))) {
    retrieveCachedData(store, reducerActions, companyId, branchId)
}
